import i18n from '@/i18n'
import { useUserStore } from '@/stores/user'

export function useGeneralities() {
	const userStore = useUserStore()

	// Methods
	function openDialogBox(message, title, buttonTitle, type) {
		const dialogInfo = {
			message,
			title,
			buttonTitle,
			type,
			dialogOn: true,
		}
		userStore.modifyDialogInfo(dialogInfo)
	}

	function closeDialogBox() {
		const dialogInfo = {
			message: '',
			title: '',
			buttonTitle: '',
			type: '',
			dialogOn: false,
		}
		userStore.modifyDialogInfo(dialogInfo)
	}

	function formatPrice(value) {
		let val = (value / 1).toFixed(2).replace(',', '.')
		return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
	}

	function format2Digits(value) {
		let val = (value / 1).toFixed(2).replace(',', '.')
		return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
	}

	function formatDate(d) {
		return d.substring(5, 7) + '-' + d.substring(8, 10) + '-' + d.substring(0, 4)
	}

	function formatAddress(addr) {
		if (addr) {
			let formattedAddress = addr.street ? addr.street : ''
			formattedAddress += addr.city ? ',\n' + addr.city : ''
			formattedAddress += addr.state ? ', ' + addr.state : ''
			formattedAddress += addr.postalCode ? ' ' + addr.postalCode.toUpperCase() : ''
			formattedAddress += addr.country ? ', ' + addr.country : ''
			return formattedAddress
		}
		return i18n.t('notFound')
	}

	function formatAddressFromFields(street, city, state, postalCode, country) {
		if (street || city || state || postalCode || country) {
			let formattedAddress = street ? street : ''
			formattedAddress += city ? ',\n' + city : ''
			formattedAddress += state ? ', ' + state : ''
			formattedAddress += postalCode ? ' ' + postalCode.toUpperCase() : ''
			formattedAddress += country ? ', ' + country : ''
			return formattedAddress
		}
		return i18n.t('notFound')
	}

	return {
		openDialogBox,
		closeDialogBox,
		formatPrice,
		format2Digits,
		formatDate,
		formatAddress,
		formatAddressFromFields,
	}
}
